module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("Thank you for supporting authors and literacy by purchasing this book. Want to add more gripping reads to your library? As the author of more than a dozen award-winning and bestselling books, you can find all of Pamela Crane’s works on her website at "), _c('a', {
    staticClass: "text_",
    attrs: {
      "href": "http://www.pamelacrane.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.pamelacrane.com")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f632f26a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 66
// module chunks = 0